import { useState, useMemo } from "react";
import { useLatest } from "../../../hooks";
import { fetchLocationOptions } from "../utils";

export function useLocationOptions() {
  const [options, setOptions] = useState();
  useLatest(async (signal) => {
    setOptions(await fetchLocationOptions(signal));
  }, []);

  return useMemo(
    () => ({ options: options ?? [], loading: options == null }),
    [options],
  );
}
